import { VIEWER_THEME_COLOR_OPTIONS } from '@/data/viewerColorOptions'
import { getContrastRatio, TEXT_CONTRAST_THRESHOLD } from '@/utils/colorUtils'

const THEME_KEYS = VIEWER_THEME_COLOR_OPTIONS.map(o => o.value)

// Stored opened-artwork color -> theme key, or '' (follow theme).
// Legacy hex values map to a matching theme color, otherwise follow the theme.
export function normalizeViewerColor(value, theme) {
  theme = theme || {}
  if (!value || typeof value !== 'string') return ''
  if (THEME_KEYS.includes(value)) return value
  if (!value.startsWith('#')) return ''
  const hex = value.toLowerCase()
  return THEME_KEYS.find(k => theme[k]?.toLowerCase() === hex) || ''
}

// Hex for a stored opened-artwork color, or '' to follow the theme
export function resolveViewerColor(value, theme) {
  theme = theme || {}
  const key = normalizeViewerColor(value, theme)
  return key ? theme[key] || '' : ''
}

// True when the saved panel colors would be unreadable under this theme
export function panelColorsClash(gallery, theme) {
  gallery = gallery || {}
  theme = theme || {}
  const bg = resolveViewerColor(gallery.viewerPanelBg, theme) || theme.bgColor
  const text = resolveViewerColor(gallery.viewerPanelText, theme) || theme.textColor
  return Boolean(bg && text) && getContrastRatio(text, bg) < TEXT_CONTRAST_THRESHOLD
}

// Outline-button vars for a panel with its own colors: outline in the panel text, filled in the panel bg
export function panelOutlineVars(panelBg, panelText) {
  return {
    '--color-outline-button': panelText,
    '--color-outline-button-text': panelBg
  }
}
